export default class PageHero {
    constructor() {
        this.pageHero = document.querySelector('[data-page-hero]');
        if (!this.pageHero)
            return;
        this.header = document.querySelector('header');
        this.desktopNavigationColumn = this.header.querySelector('.row .col-navigation');
        this.setTitleColumnWidth();
        this.addEventListeners();
    }
    addEventListeners() {
        window.addEventListener('resize', () => this.setTitleColumnWidth());
    }
    setTitleColumnWidth() {
        this.heroTitleColumn = this.pageHero.querySelector('.col-title');
        if (!this.heroTitleColumn)
            return;
        this.heroTitleWidth = this.desktopNavigationColumn.offsetWidth;
        if (this.heroTitleWidth > 1000 && this.heroTitleColumn.parentElement.classList.contains('title-row')) {
            this.heroTitleWidth += 22; // Minimum width
        }
        this.heroTitleColumn.style.setProperty('--hero-title-w', `${this.heroTitleWidth}px`);
    }
}
